import apiModules from '@/apis';

export default {
    install(app) {
        app.config.globalProperties.$api = apiModules; // Attach all API modules globally
    },
};
